"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";

export function RouteChangeListener() {
  const pathname = usePathname();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const previousPath = previousPathRef.current;

    const previousSegment = getFirstPathSegment(previousPath);
    const currentSegment = getFirstPathSegment(pathname);

    if (previousSegment !== currentSegment) {
      const mainElm = document.querySelector("main");
      if (mainElm) {
        // setting time out for iOS webview
        setTimeout(() => {
          mainElm.scrollTop = 0;
        }, 50);
      }
    }

    previousPathRef.current = pathname;
  }, [pathname]);

  return null;
}

const getFirstPathSegment = (path: string | null) =>
  path?.split("/")[1] ?? null;
